/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Keen_Warm_Seal_SwimInputs */

const en_keen_warm_seal_swim = /** @type {(inputs: Keen_Warm_Seal_SwimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add source`)
};

const de_keen_warm_seal_swim = /** @type {(inputs: Keen_Warm_Seal_SwimInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quelle hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add source" |
*
* @param {Keen_Warm_Seal_SwimInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const keen_warm_seal_swim = /** @type {((inputs?: Keen_Warm_Seal_SwimInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Keen_Warm_Seal_SwimInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_keen_warm_seal_swim(inputs)
	return de_keen_warm_seal_swim(inputs)
});